// TODO change to uppercase?
enum PortfolioMode {
  STUDENT = 'student',
  COACH = 'coach',
}

export default PortfolioMode;
